import { Box, Button, FormControlLabel, InputBase, Paper } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const SearchBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const FiltersContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '24px',
}));

export const CSVButton = styled(Button)(({ theme }) => ({
  width: 200,
  gap: 8,
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  borderRadius: '32px',
  border: `1px solid ${theme.palette.secondary.main}`,
  padding: '0 18px',
  height: '56px',
  '& .MuiInputBase-input': {
    width: '200px',
    padding: '10px 0 10px',
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('md')]: {
      width: '200px',
      '&:focus': {
        width: '300px',
      },
    },
  },
}));

export const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  borderColor: isActive ? theme.palette.primary.main : theme.palette.grey[400],
  transition: 'all 0.2s ease-in-out',
  borderRadius: '12px',
  minWidth: 254,
  '&:hover': {
    borderColor: isActive
      ? theme.palette.primary.main
      : theme.palette.grey[600],
  },
  backgroundColor: isActive
    ? alpha(theme.palette.primary.light, 0.1)
    : 'transparent',
}));

export const StyledFormLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  margin: theme.spacing(1),
  '& .MuiFormControlLabel-label': {
    color: isActive ? theme.palette.primary.main : 'inherit',
    fontWeight: isActive ? 500 : 400,
  },
}));
